var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.59 88.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5c1e7;}.cls-2{fill:#baa1de;}.cls-3{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.59,49.42A39.22,39.22,0,0,1,48.37,88.64c-21.66,0-40.76-18.32-40.76-40s20-29.35,41.64-29.35S87.59,27.76,87.59,49.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.65,35.67C27.83,29,27.46,16.61,34.82,8S55.29-2.7,63.11,4s3.81,17-3.55,25.65S43.47,42.33,35.65,35.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5,72C.48,68.15-.34,61.65,3.2,57.5s10.5-4.56,15-.7,2.89,9.07-.65,13.23S9.55,75.88,5,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.84,68.49S45.7,52.13,47.92,53c1.81.68,6.95,14.68,8.78,19.79a1.09,1.09,0,0,0,1.87.32c3.73-4.57,14.83-17.7,17.36-15.4,3,2.77,4.16,20,4.16,20.52"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic10);
export default __webpack_public_path__ + "static/media/Pic10.2cf282c872a8499160021cfdb1d84dd8.svg";
export { ForwardRef as ReactComponent };